/* src/app/views/template/components/edit-template-menu/edit-template-product-menu/edit-template-product-menu-footer/edit-template-product-menu-footer.component.scss */
/*# sourceMappingURL=edit-template-product-menu-footer.component.css.map */
